// src/utils/axiosInstance.js
import axios from 'axios';
import { getAccessToken } from './auth';

const axiosInstance = axios.create();

axiosInstance.interceptors.request.use(async (config) => {
  const token = await getAccessToken();
  config.headers.Authorization = `Bearer ${token}`;
  return config;
}, (error) => {
  return Promise.reject(error);
});

export default axiosInstance;
